import { useMemo, useState } from 'react'
import { Button } from '@winnin/winnin_ui.components.button'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Image } from '@winnin/winnin_ui.components.image'
import { Title } from '@winnin/winnin_ui.components.title'

// @ts-expect-error - file not typed
import ShareOfAttentionAnimation from 'assets/images/gif/share-of-attention-rank-animation.gif'
import { ReactSelect as Select } from 'components'
import { useBrandRanking } from 'contexts/BrandRankingContext'
import { useBrandsCategories } from 'hooks/useBrandsCategories'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { TOLGEE_KEYS } from './translate'

import './styles.scss'

type Option = (typeof options)[number]

interface SetupWorkspaceCategoryProps {
  page: 'Zai Mobile' | 'Home Category'
}

export function SetupWorkspaceCategory({ page }: SetupWorkspaceCategoryProps) {
  const t = useTranslate()
  const { chooseCategory, selectedWorkspaceCategory } = useBrandRanking()

  const { categories } = useBrandsCategories()

  const categoriesOptions = useMemo(() => {
    return categories.map(category => ({
      label: category?.name,
      value: category?.id,
    }))
  }, [categories])

  const [selectedCategory, setSelectedCategory] = useState<Option | null>(null)

  const handleCategoryChange = category => {
    setSelectedCategory(category)
  }

  const handleSubmit = () => {
    chooseCategory(selectedCategory?.label, {
      mixpanelProps: {
        Page: page,
      },
    })
  }

  return (
    <div className="SetupWorkspaceCategory">
      <div className="SetupWorkspaceCategory-hero">
        <Image src={ShareOfAttentionAnimation} alt="Share of attention animation" />
      </div>

      <div className="SetupWorkspaceCategory-content">
        <Title className="SetupWorkspaceCategory-title" variation="primary" tag="h2">
          {t(TOLGEE_KEYS.title)}
        </Title>

        <p className="SetupWorkspaceCategory-text">{t(TOLGEE_KEYS.descrition)}</p>
      </div>

      {selectedWorkspaceCategory ? (
        <div className="SetupWorkspaceCategory-info">
          <Icon icon="smallCheckbox" fill="var(--color_success_500)" width={9} height={9} />
          <p className="SetupWorkspaceCategory-info-text">{t(TOLGEE_KEYS.successMessage)}</p>
        </div>
      ) : (
        <div className="SetupWorkspaceCategory-form">
          <Select
            containerClass="language-selector"
            value={selectedCategory}
            onChange={handleCategoryChange}
            label={t(TOLGEE_KEYS.label)}
            placeholder={t(TOLGEE_KEYS.placeholder)}
            options={categoriesOptions}
            isOptionDisabled={option => option.disabled === true}
            maxMenuHeight={150}
          />
          <div className="SetupWorkspaceCategory-form-actions">
            {!!selectedCategory && (
              <Button onClick={handleSubmit} disabled={!selectedCategory}>
                {t(TOLGEE_GLOBALS.confirm)}
              </Button>
            )}
          </div>
        </div>
      )}
    </div>
  )
}
